<div *ngIf="listView" style="margin: 5px">
	<button
		mat-stroked-button
		color="accent"
		*ngIf="totalUnread() > 0"
		style="width: 100%"
		class="sms-message"
		(click)="markSMSesAsReadAll(conversations)"
	>
		<mat-icon class="mat-accent-icon">sms</mat-icon>
		{{ ('COMMUNICATIONS.mark_all_as_read' | translate | capitalize).replace('{0}', totalUnread()) }}
	</button>

	@for (conversation of conversations; track $index) {
		<div
			class="sms-message"
			(click)="showSelectedSMS(conversation)"
			[matBadge]="conversation?.smsUnread"
			[matBadgeHidden]="conversation?.smsUnread === 0"
			matBadgeColor="accent"
		>
			<div style="display: flex; justify-content: space-between; align-items: center">
				<div style="display: flex; align-items: center; gap: 6px">
					<div style="display: flex; flex-direction: column" *ngIf="conversation?.smsType === 'BOO'">
						<strong>{{ conversation?.contactName }}</strong>
					</div>
					<div style="display: flex; flex-direction: column" *ngIf="conversation?.smsType === 'CRE'">
						<strong>{{ conversation?.name }}</strong>
					</div>
					<mat-chip *ngIf="conversation?.smsType === 'CRE'" disabled>{{ 'COMMUNICATIONS.crew' | translate }}</mat-chip>
				</div>
				<div style="display: flex; flex-direction: column; font-size: 11px">{{ formatDate(conversation?.smsLatest?.date) }}</div>
			</div>
			<div style="display: flex; justify-content: space-between; align-items: center">
				<div style="display: flex; align-items: center; gap: 6px; min-width: 0">
					<app-monty-tag [tag]="conversation?.montyTag" [open]="conversation?.montyOpen"></app-monty-tag>
					<span *ngIf="conversation?.smsLatest?.direction === 'OUT'" style="font-style: italic"
						><strong>{{ 'COMMUNICATIONS.you' | translate | capitalize }}:&nbsp;</strong></span
					>
					{{ conversation?.smsLatest?.summary }}
				</div>
				<app-sms-status-icon
					*ngIf="conversation?.smsLatest?.direction === 'OUT'"
					[status]="conversation?.smsLatest?.status"
					[error]="conversation?.smsLatest?.error"
				></app-sms-status-icon>
			</div>
		</div>
	}
</div>
<div *ngIf="!listView" style="margin: 5px">
	<!-- Detail header -->
	<div style="display: flex; justify-content: space-between; align-items: center">
		<div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center; min-width: 20px">
			<button mat-icon-button (click)="showSMSList(selectedConversation)">
				<mat-icon>keyboard_arrow_left</mat-icon>
			</button>
		</div>
		<div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center; min-width: 60px">
			<div>
				<strong>{{ selectedConversation?.name }}</strong>
			</div>
			<div>{{ selectedConversation?.phone }}</div>
		</div>
		<div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center; min-width: 20px">
			<div style="display: flex; align-items: center" *ngIf="selectedConversation?.smsUnread != 0">
				<mat-icon class="mat-accent-icon" [matBadge]="selectedConversation?.smsUnread" matBadgeColor="warn" aria-hidden="false"
					>sms</mat-icon
				>
			</div>
			<div
				style="display: flex; align-items: center"
				*ngIf="selectedConversation?.smsLatest?.direction === 'OUT' && selectedConversation?.smsUnread === 0"
			>
				<mat-icon class="mat-error-icon">sms_failed</mat-icon>
			</div>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div *ngIf="selectedConversation?.smsType === 'BOO'" style="display: flex; justify-content: space-between; margin-top: 10px">
		<button [disabled]="!selectedBooking" mat-flat-button (click)="viewDetailsBooking(selectedBooking)">
			<mat-icon>perm_contact_calendar</mat-icon>{{ selectedBooking?.passengerCounters?.passengerCount }} PAX
		</button>
		<button *ngIf="selectedBooking?.flight?.date" mat-flat-button (click)="viewDetailsFlight(selectedBooking)">
			<mat-icon>flight_takeoff</mat-icon>{{ selectedBooking?.flight?.date | formatDate: 'ddd DD MMM' }}
		</button>
	</div>

	<!-- 2026-09-02: always-available template send (cloud tenants) — same reach as before the 24h
	     window restriction existed, not only shown when the window happens to be closed. -->
	<div *ngIf="showTemplateButton" style="display: flex; justify-content: flex-end; margin-top: 6px">
		<button mat-stroked-button color="accent" (click)="openTemplatePicker()">
			<mat-icon>description</mat-icon>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.templatePickerButton' | translate | capitalize }}
		</button>
	</div>

	<!-- Connection status indicator (013-whatsapp-transition) — hidden once the window is closed,
	     the locked-composer panel below is the single message about the send state then. -->
	@if (whatsapp?.enabled && !windowClosedForFreeform) {
		<app-connection-status></app-connection-status>
	}

	<!-- Hint: WA confirmed disconnected + fallback off + credits available -->
	@if (whatsappConnected === false && whatsapp?.enabled && !whatsapp?.fallbackSms && hasSmsBalance) {
		<div class="fallback-hint">
			<mat-icon>info_outline</mat-icon>
			<span>{{ 'COMMUNICATIONS.fallback_hint' | translate | capitalize }}</span>
		</div>
	}

	<!-- Monty (088): pending booking action + reply-proposal strip. The send
	     button is the accept for the reply; the action needs its own button. -->
	<!-- 224: what the customer asked for and what QR found (decided by the system, not the model) -->
	@if (selectedConversation?.smsType === 'BOO' && (montyActionPending || montyReplyOpen) && montyFacts) {
		<div class="monty-facts">
			@for (r of montyProposal?.requested || []; track r.date) {
				<div class="monty-fact">
					<span class="material-symbols-outlined">event</span>
					<span>{{ 'MONTY.requested_prefix' | translate | capitalize }}</span>
					<span class="monty-fact-text">{{
						'MONTY.requested_' + r.outcome | translate: { date: montyDay(r.date), flight: r.flightLabel, free: r.freeSpots }
					}}</span>
				</div>
			}
			@if (montyProposal?.dateConflict) {
				<div class="monty-fact monty-fact-muted">
					<span class="material-symbols-outlined">info</span>
					<span>{{ 'MONTY.date_conflict' | translate | capitalize }}</span>
				</div>
			}
			@if (montyProposal?.needsReview) {
				<div class="monty-fact monty-fact-warn" [matTooltip]="(montyProposal?.unverified || []).join(', ')">
					<span class="material-symbols-outlined">warning</span>
					<span>{{ 'MONTY.needs_review' | translate: { items: (montyProposal?.unverified || []).join(', ') } | capitalize }}</span>
				</div>
			}
		</div>
	}
	@if (selectedConversation?.smsType === 'BOO' && montyActionPending) {
		<app-monty-action-card
			[action]="montyProposal?.action"
			[busy]="montyActionBusy"
			[failureReason]="montyActionFailure"
			(accept)="montyAcceptAction($event)"
			(dismiss)="montyDismissAction()"
		></app-monty-action-card>
	}
	@if (selectedConversation?.smsType === 'BOO' && montyReplyOpen && montyPrefilled) {
		<div class="monty-strip">
			<span class="monty-glyph"><span class="material-symbols-outlined">person_raised_hand</span></span>
			<span>{{ 'MONTY.proposal_strip' | translate | capitalize }}</span>
			<button mat-icon-button (click)="montyClearProposal()" [matTooltip]="'MONTY.proposal_clear' | translate | capitalize">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	} @else if (selectedConversation?.smsType === 'BOO' && montyReplyOpen && montyInsertAvailable) {
		<div class="monty-strip monty-strip-insert" (click)="montyInsertDraft()">
			<span class="monty-glyph"><span class="material-symbols-outlined">person_raised_hand</span></span>
			<span>{{ 'MONTY.proposal_insert' | translate | capitalize }}</span>
		</div>
	}

	<!-- Simplified messaging flow - use WhatsApp when enabled (013-whatsapp-transition) -->
	@if (whatsapp?.enabled) {
		<ng-container *ngTemplateOutlet="replyformWhatsApp"></ng-container>
	} @else {
		<ng-container *ngTemplateOutlet="replyformSMS"></ng-container>
	}

	<!-- messages -->
	<div *ngIf="messages?.length != 0">
		@for (message of messages; track $index; let i = $index) {
			<div *ngIf="i === 0" style="display: flex; justify-content: center; align-items: center" class="sms-date">
				{{ formatDate(message?.date?.sms) }}
			</div>
			<div *ngIf="i > 0">
				<div
					style="display: flex; justify-content: center; align-items: center"
					class="sms-date"
					*ngIf="formatDate(message?.date?.sms) != formatDate(messages[i - 1]?.date?.sms)"
				>
					{{ formatDate(message?.date?.sms) }}
				</div>
			</div>
			<div style="display: flex; justify-content: end; align-items: center; gap: 10px" *ngIf="message?.direction === 'OUT'">
				<div class="sms-message sms-message-out">
					<div style="display: flex; justify-content: space-between; align-items: center; gap: 10px">
						<app-sms-status-icon
							*ngIf="message?.eventSummary"
							[status]="message?.eventSummary?.status"
							[error]="message?.eventSummary?.error"
							[provider]="message?.provider"
						></app-sms-status-icon>
						<span *ngIf="message?.fallbackUsed" class="fallback-badge">WA→SMS</span>
						<div style="text-align: right; word-wrap: break-word; width: 190px">
							<span style="font-style: italic"
								><strong>{{ 'COMMUNICATIONS.you' | translate | capitalize }}:&nbsp;</strong></span
							>
							<app-wa-message [message]="message"></app-wa-message>
						</div>
					</div>
				</div>
			</div>
			<div style="display: flex; align-items: center; gap: 10px" *ngIf="message?.direction === 'IN'">
				<div class="sms-message sms-message-in">
					<div style="display: flex; justify-content: space-between; align-items: center; gap: 10px">
						<span *ngIf="message?.fallbackUsed" class="fallback-badge">WA→SMS</span>
						<div style="text-align: left; word-wrap: break-word" [ngStyle]="{ color: message?.date?.read ? '' : '#42A5F5' }">
							<app-wa-message [message]="message"></app-wa-message>
						</div>
						<app-monty-tag [tag]="message?.monty?.tag"></app-monty-tag>
					</div>
					<!-- visible confirmation of an accepted Monty action (FR-015) -->
					@if (message?.monty?.proposal?.action?.accepted) {
						<div class="monty-sysline">✓ {{ 'MONTY.action_accepted_line' | translate | capitalize }}</div>
					}
					<!-- @if (message?.wa?.pushname) {
						<span style="font-size: small; color: grey; font-style: italic; padding-top: 12px"
							>{{ message.wa.pushname }} - {{ message?.wa?.timestamp | formatDate: 'DD-MMM-YY hh:mm:ss' }}</span
						>
					} -->
				</div>
			</div>
		}
	</div>
</div>

<ng-template #replyformSMS>
	<!-- reply form SMS -->
	<div style="margin: 10px 0px; background-color: #f0f0f0">
		<div style="display: flex; justify-content: space-between; align-items: center; padding: 5px">
			<mat-form-field appearance="outline" style="width: 100%">
				<mat-label>{{ 'FLIGHTS.sms' | translate | capitalize }}</mat-label>
				<textarea cdkAutosizeMinRows="2" cdkTextareaAutosize matInput name="sms" [(ngModel)]="replyText"></textarea>
				<mat-hint style="font-size: 11">{{ characterCount(replyText) }} chars left - {{ smsCount(replyText) }} sms</mat-hint>
			</mat-form-field>
			<button mat-icon-button (click)="smsReply(selectedConversation)">
				<mat-icon>send</mat-icon>
			</button>
		</div>
		<div
			*ngIf="upEnabled && selectedConversation?.smsType === 'BOO'"
			style="display: flex; justify-content: space-between; align-items: center; padding: 5px"
		>
			<mat-slide-toggle [(ngModel)]="smsUp">{{ 'FLIGHTS.send_up_url_with_sms' | translate | capitalize }}</mat-slide-toggle>
		</div>
	</div>
	<mat-divider></mat-divider>
</ng-template>
<ng-template #replyformWhatsApp>
	<!-- reply form WhatsApp -->
	<div style="margin: 10px 0px; background-color: #f0f0f0">
		<!-- 2026-09-02: cloud tenant, window closed — free text has no template to fall back to, so
		     the whole composer (input + UP/flight-options toggles) is replaced by one compact panel
		     with the template CTA, instead of showing a disabled box underneath a warning. -->
		<div *ngIf="windowClosedForFreeform" class="window-closed-panel">
			<div class="window-closed-panel-text">
				<mat-icon>lock_clock</mat-icon>
				<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.windowClosedFreeform' | translate }}</span>
			</div>
			<button mat-flat-button color="accent" (click)="openTemplatePicker()">
				<mat-icon>description</mat-icon>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.templatePickerButton' | translate | capitalize }}
			</button>
		</div>
		<div *ngIf="!windowClosedForFreeform" style="display: flex; justify-content: space-between; align-items: center; padding: 5px">
			<div style="display: flex; flex-direction: column; gap: 5px; align-items: left; width: 100%">
				<mat-form-field appearance="outline" style="width: 100%">
					<mat-label *ngIf="!whatsappStatusLoaded || whatsappConnected || !(whatsapp?.fallbackSms && hasSmsBalance)">{{ 'FLIGHTS.message_whatsapp' | translate | capitalize }}</mat-label>
					<mat-label *ngIf="whatsappStatusLoaded && !whatsappConnected && whatsapp?.fallbackSms && hasSmsBalance">{{ 'FLIGHTS.message_sms_fallback' | translate | capitalize }}</mat-label>
					<textarea cdkAutosizeMinRows="2" cdkTextareaAutosize matInput name="sms" [(ngModel)]="replyText"></textarea>
				</mat-form-field>
				@if (smsUp) {
					<mat-form-field appearance="outline" style="width: 100%">
						<mat-label>UP url</mat-label>
						<textarea
							cdkAutosizeMinRows="2"
							cdkTextareaAutosize
							matInput
							disabled="true"
							[value]="('FLIGHTS.upTitle' | translate | capitalize) + '\nhttps://up.qrel.eu?...'"
						></textarea>
					</mat-form-field>
				}
				@if (smsFlightOptions) {
					<mat-form-field appearance="outline" style="width: 100%">
						<mat-label>{{ 'FLIGHTS.flightOptions' | translate | capitalize }}</mat-label>
						<textarea
							cdkAutosizeMinRows="2"
							cdkTextareaAutosize
							matInput
							disabled="true"
							[value]="'FLIGHTS.flightOptionsTitle' | translate | capitalize"
						></textarea>
					</mat-form-field>
				}
			</div>
			<button mat-icon-button (click)="messageReply(selectedConversation)" [disabled]="!whatsappStatusLoaded || (!whatsappConnected && !(whatsapp?.fallbackSms && hasSmsBalance))"
				[matTooltip]="whatsappStatusLoaded && !whatsappConnected && !(whatsapp?.fallbackSms && hasSmsBalance) ? ('SETTINGS.MESSAGING.STATUS_DISCONNECTED' | translate | capitalize) : ''">
				<mat-icon>send</mat-icon>
			</button>
		</div>
		<div
			*ngIf="upEnabled && selectedConversation?.smsType === 'BOO' && !windowClosedForFreeform"
			style="display: flex; flex-direction: column; justify-content: space-between; align-items: left; padding: 5px; gap: 5px"
		>
			<mat-slide-toggle [(ngModel)]="smsUp" [disabled]="!whatsappStatusLoaded || (!whatsappConnected && !(whatsapp?.fallbackSms && hasSmsBalance))">{{ 'FLIGHTS.send_up_url_with_msg' | translate | capitalize }}</mat-slide-toggle>
			<mat-slide-toggle [(ngModel)]="smsFlightOptions" [disabled]="!whatsappStatusLoaded || (!whatsappConnected && !(whatsapp?.fallbackSms && hasSmsBalance))">{{
				'FLIGHTS.send_flightoptions_with_msg' | translate | capitalize
			}}</mat-slide-toggle>
		</div>
	</div>
	<mat-divider></mat-divider>
</ng-template>
